/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * Make sure this isn't imported in the analytics worker
 *	> 'owa-local-storage' import is restricted from being used. localStorage is not available in the analytics worker [analytics-worker-lint] */
import { setItem, getItem } from "owa-local-storage";
import type { LogicalRing } from "owa-config-types";
import type { AccountKey } from "owa-client-types";
import type { MailboxAccountInfoMappingAddon } from "owa-analytics-types";
import { GLOBAL_ACCOUNT_CACHE_KEY } from "owa-analytics-types";
import { getAnalyticsAddon } from "owa-analytics-addons";

const LogicalRingKey = "LogicalRing";

const logicalRingByAccount = new Map<string, LogicalRing>();

export function setLogicalRing(ring: LogicalRing, accountKey: AccountKey | "globalAccount"): void {
    const cacheKey = getCacheKey(accountKey);
    if (logicalRingByAccount.get(cacheKey) === ring) {
        return;
    }
    logicalRingByAccount.set(cacheKey, ring);
    setItem(self, `${LogicalRingKey}_${cacheKey}`, ring);
    return;
}

export function getLogicalRing(accountKey?: AccountKey | "globalAccount"): LogicalRing | null {
    const cacheKey = getCacheKey(accountKey ?? "globalAccount");
    let ring = logicalRingByAccount.get(cacheKey);
    if (!ring) {
        ring = (getItem(self, `${LogicalRingKey}_${cacheKey}`) as LogicalRing | null) ?? undefined;
    }
    return ring ?? null;
}

export function getCacheKey(accountKey: AccountKey | "globalAccount"): string {
    const addon = getAnalyticsAddon<MailboxAccountInfoMappingAddon>("MailboxAccountInfoMapping");
    
    if (addon.isRegistered) {
        const cacheKey = addon?.executeNow()?.getMailboxCacheKey(accountKey, "getSessionInfo");
        return cacheKey;
    }
    
    return GLOBAL_ACCOUNT_CACHE_KEY;
}
